import type { ReactElement } from 'react'

import { getBulkPrice } from '../../utils/bulkPrices'
import { useProductDetailState } from './ProductDetailProvider'
import { useTranslate } from '../../utils/translate'

export type PriceProps = {
  product: Frontend.Product
  className: string
}

export default function Price({ product, className }: Readonly<PriceProps>): ReactElement {
  const { quantity } = useProductDetailState()
  const t = useTranslate('shop')

  const price = product.bulkPrices ? getBulkPrice(product, quantity)?.formatted : product.price?.formatted

  return (
    <div className={className}>
      <span className="visually-hidden">
        {t('components.productComponent.singlePrice.accessibilityLabel', {
          price: price,
        })}
      </span>
      <span aria-hidden="true" data-testid="product-price">
        {price}
      </span>
    </div>
  )
}
